<div class="feed-item">
  @switch (true) {
    @case (isRewardCardType) {
      <ng-container *ngTemplateOutlet="rewards; context: { $implicit: feed }"></ng-container>
    }
    @case (feed.CardType === cardType.Advert) {
      <ng-container *ngTemplateOutlet="adverts; context: { $implicit: feed }"></ng-container>
    }
    @case (feed.CardType === cardType.Wallet) {
      <ng-container *ngTemplateOutlet="wallets; context: { $implicit: feed }"></ng-container>
    }

    <!-- @case (feed.CardType === cardType.OfferRow) {
      <ng-container *ngTemplateOutlet="offers; context: { $implicit: feed }"></ng-container>
    } -->
    @case (isComponentCardType) {
      <ng-template #container></ng-template>
    }
  }
</div>

<!-- Rewards -->
<ng-template #rewards let-feed>
  <div class="feed feed-rewards-item">
    <div class="img-wrapper">
      <div class="img-container">
        <img alt="" fgbImgPreload [dataSrc]="feed.Data.Image" [imgOptions]="{ variantId: '7', loyaltyType: 'marketplace' }" />
      </div>
    </div>

    <div class="feed-reward-body">
      <div class="feed-reward-details">
        <span class="reward-type">{{ rewardType?.label | translate }}</span>
        <fgbcl-countdown-v2 class="font-size-12" [endDateTime]="feed?.Data.EndDate"></fgbcl-countdown-v2>
      </div>
      <h5 class="feed-title">{{ feed?.Data.Title }}</h5>
      <div class="feed-points">
        {{
          feed.Data.PointValue || feed.Data.MerchantValue
            ? (feed.Data.PointValue || feed.Data.MerchantValue) + ' ' + ('fgbcl.currency.pts' | translate)
            : ('fgbcl.currency.free' | translate)
        }}
      </div>
    </div>

    <div class="action-wrapper">
      <a class="btn feed-btn fw-bold" [routerLink]="[rewardType?.route, feed.Data.Id]">
        {{ rewardType?.button | translate }}
      </a>
    </div>

    @if (feed?.Data?.Sponsor?.SponsorImage) {
      <div class="feed-sponsor-section mt-0">
        <div class="feed-sponsor-text">{{ feed?.Data?.Sponsor?.SponsorText }}:</div>
        <a
          [attr.href]="feed?.Data?.Sponsor?.SponsorLink || null"
          [attr.target]="feed?.Data?.Sponsor?.SponsorLink ? '_blank' : null"
          [attr.rel]="feed?.Data?.Sponsor?.SponsorLink ? 'noopener noreferrer' : null"
        >
          <img class="feed-sponsor-image" [src]="feed.Data.Sponsor.SponsorImage | contentImage: '1'" />
        </a>
      </div>
    }
  </div>
</ng-template>

<!-- Advert -->
<ng-template #adverts let-feed>
  <div class="feed feed-advert">
    <div class="img-wrapper-advert">
      <div class="img-container-advert">
        <img alt="" fgbImgPreload [dataSrc]="feed.Data.Image" [imgOptions]="{ variantId: '7', loyaltyType: 'marketplace' }" />
      </div>
    </div>
    <ng-container *ngIf="feed.Data?.LinkUrl">
      <div class="action-wrapper">
        <a href="{{ feed.Data?.LinkUrl }}" class="btn fw-bold">{{ feed.Data?.ButtonText }}</a>
      </div>
    </ng-container>
  </div>
</ng-template>

<!-- Wallet -->
<ng-template #wallets let-feed>
  <div class="feed feed-wallet">
    <div class="feed-wallet-body w-100 h-100">
      <div class="feed-wallet-title">
        <h5 class="feed-wallet-heading">{{ 'fgbcl.feed.wallet.title' | translate }}</h5>
        <span class="feed-wallet-subtext wallet-header">{{ 'fgbcl.feed.wallet.description' | translate }}</span>
      </div>

      <div class="feed-wallet-details">
        <div class="img-wrapper">
          <div class="img-container">
            <img alt="" fgbImgPreload [dataSrc]="feed.Data.Image" [imgOptions]="{ variantId: '7', loyaltyType: 'marketplace' }" />
          </div>
        </div>
        <div>
          <h5 class="text-center feed-title">{{ feed?.Data?.Title }}</h5>
          @if (feed?.Data?.ExpiryDate) {
            <div class="text-center feed-title fw-normal">
              {{ 'fgbcl.feed.wallet.expiry' | translate }}
              {{ feed.Data.ExpiryDate | UtcToLocaltimePipe: dateOption.LongDateFormat }}
            </div>
          }
        </div>
      </div>

      <div class="action-wrapper">
        @if ([1, 2, 3].includes(feed?.Data?.ItemType)) {
          <a class="btn btn-primary fw-bold" [routerLink]="getRewardRoute(feed?.Data)">
            {{ 'fgbcl.feed.wallet.claim' | translate }}
          </a>
        }
      </div>
    </div>
  </div>
</ng-template>

<!-- Offers -->
<!-- <ng-template #offers let-feed>
  <div class="feed">
    <div class="feed-offer-body">
      <div class="img-wrapper">
        <div class="img-container">
          <img alt="" fgbImgPreload [dataSrc]="feed.Data.Image" [imgOptions]="{ variantId: '7', loyaltyType: 'marketplace' }" />
        </div>
      </div>

      <h5 class="text-center feed-title pt-3">{{ feed?.Data?.Title }}</h5>
      <span class="text-center feed-title fw-normal" *ngIf="feed?.Data?.ExpiryDate"
        >Expires: {{ feed?.Data?.ExpiryDate | date: 'MMM dd, YYYY' }}</span
      >

      <div class="action-wrapper">
        <a class="btn btn-primary fw-bold" [routerLink]="['/rewards/offers']">View Offers</a>
      </div>
    </div>
  </div>
</ng-template> -->
